module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-2021.c7fbb59d.jpg";